import { Login } from 'domains/auth'
import AppAuthentication from 'domains/auth/screens/AppAuthentication'
import { Contacts } from 'domains/contact/screens'
import { Events } from 'domains/event/screens'
import { Zones } from 'domains/zone/screens'
import { Management } from 'domains/profile/screens'
import {
  CreditCard,
  DirectDebit,
  Method,
  PendingAccounts,
} from 'domains/payment'

import Home from './screens/Home'

import { parseCookies } from 'nookies'
import { useEffect } from 'react'

import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { MainContainer } from 'routes/components/MainContainer/MainContainer'

export const UbiRoutes: React.FC = () => {
  interface StartedSessionContainerProps {
    children: JSX.Element
  }

  const StartedSessionContainer = ({
    children,
  }: StartedSessionContainerProps) => {
    const location = useLocation()
    const navigate = useNavigate()

    const { userId } = parseCookies()

    useEffect(() => {
      if (!userId && location.pathname !== '/login') {
        navigate('/login', { state: { from: location } })
      }
    }, [])

    return children
  }

  return (
    <Routes location={location}>
      <Route path="/:clientId/:userId" element={<AppAuthentication />} />
      <Route path="/login" element={<Login />} />
      <Route path="/payment-method/:userId" element={<Method />} />
      //TODO: improve route system
      <Route path="/credit-card/:accountId/create" element={<CreditCard />} />
      <Route path="/credit-card/:accountId/edit" element={<CreditCard />} />
      <Route path="/direct-debit/:accountId/create" element={<DirectDebit />} />
      <Route path="/direct-debit/:accountId/edit" element={<DirectDebit />} />
      <Route path="/pending-accounts/:userId" element={<PendingAccounts />} />
      <Route
        path="/"
        element={
          <StartedSessionContainer>
            <MainContainer />
          </StartedSessionContainer>
        }
      >
        <Route path="/" element={<Home />} />
        <Route path="/profile" element={<Management />} />
        <Route path="/event/list" element={<Events />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/zones" element={<Zones />} />
      </Route>
    </Routes>
  )
}
